// msa.js
// Frontend mirror of Backend/config/msa.js's CURRENT_MSA_VERSION. Keep both
// in sync by hand — bump this the same commit you bump the backend constant
// and update the agreement text in MasterServiceAgreement.js.
export const MSA_VERSION = "1.0";

export const MSA_PATH = `/master-service-agreement/v${MSA_VERSION}`;

export default MSA_VERSION;
